import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import "./index.css";
import "./styles/custom-bootstrap.scss";
// import "./styles/home-modern.css";

import App from "./App";

import { Provider } from "react-redux";
import { store } from "./redux/store";

ReactDOM.createRoot(
  document.getElementById("root")!
).render(
  <HelmetProvider>
    <Provider store={store}>
      <BrowserRouter
        basename={
          process.env.PUBLIC_URL ||
          "/"
        }
      >
        <App />
      </BrowserRouter>
    </Provider>
  </HelmetProvider>
);